import React from 'react';
import cx from 'classnames';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export interface ActionPanelProps {
  className?: string;
  ctaClassName?: string;
  ctaLabel?: React.ReactNode;
  onCtaClick?: () => void;
  cancelClassName?: string;
  cancelLabel?: React.ReactNode;
  onCancelClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export function ActionPanel({
  className,
  ctaClassName,
  ctaLabel,
  onCtaClick,
  cancelClassName,
  cancelLabel,
  onCancelClick,
  loading,
  disabled,
}: ActionPanelProps) {
  return (
    <div className={cx(className, 'flex flex-row flex-wrap gap-y-4 gap-x-4')}>
      <Button
        variant={ButtonVariant.Primary}
        className={cx(ctaClassName, 'py-2')}
        onClick={onCtaClick}
        disabled={disabled}
      >
        {ctaLabel}
        {loading && <span className='fa fa-spinner spinning ml-2' />}
      </Button>
      <Button
        variant={ButtonVariant.Secondary}
        className={cx(cancelClassName, 'py-2 v2-text-neutral-900')}
        onClick={onCancelClick}
        disabled={disabled}
      >
        {cancelLabel}
      </Button>
    </div>
  );
}
